import { Signature } from './signature.model';

export class Signatures {
    appStore: Signature;
    chat: Signature;
    facebook: Signature;
    googleMyBusiness: Signature;
    googlePlayMarket: Signature;
    instagram: Signature;
    socialBoards: Signature;
    tikTok: Signature;
    trustpilot: Signature;
    whatsApp: Signature;
    youtube: Signature;
}
